import { SnackbarContext } from "@/context/snackbar";
import { useContext } from "react";

export const useAlert = () => {
  const context = useContext(SnackbarContext);
  if (!context) {
    throw new Error("useAlert must be used within a SnackbarProvider");
  }
  return context;
}